module.exports = __webpack_public_path__ + "static/p04_burroTop-b8f98da48d33113244a96e5b4d7da99b.png";